import * as Sentry from "@sentry/react"
import React from "react"

interface Props {
  children: React.ReactNode
}

const DefaultFallback = () => (
  <div
    style={{
      padding: "2rem",
      textAlign: "center",
      minHeight: "200px",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
    }}
  >
    <h2 style={{ marginBottom: "0.5rem" }}>Something went wrong</h2>
    <p style={{ color: "#666", marginBottom: "1rem" }}>
      An unexpected error occurred. Our team has been notified.
    </p>
    <button
      onClick={() => window.location.reload()}
      style={{
        padding: "0.5rem 1.5rem",
        backgroundColor: "#000",
        color: "#fff",
        border: "none",
        borderRadius: "0.375rem",
        cursor: "pointer",
        fontSize: "0.875rem",
      }}
    >
      Reload page
    </button>
  </div>
)

export const SentryErrorBoundary: React.FC<Props> = ({ children }) => {
  return (
    <Sentry.ErrorBoundary fallback={() => <DefaultFallback />}>
      {children}
    </Sentry.ErrorBoundary>
  )
}
